import React from 'react';
import classNames from 'classnames';
import styles from './ClipsPlayPauseButton.module.scss';
import {
  ClipsPlayButtonDisabledSVG,
  ClipsPauseButtonSVG,
  ClipsPlayButtonSVG,
} from './ClipsPlayPauseSVGs';

export interface ClipsPlayPauseButtonProps {
  isPlaying: boolean;
  onClick: () => void;
  disableRewindPlayButton?: boolean;
  bgFill?: string;
  pathFill?: string;
}

const ClipsPlayPauseButton: React.FC<ClipsPlayPauseButtonProps> = ({
  isPlaying,
  onClick,
  disableRewindPlayButton,
  bgFill,
  pathFill,
}) => (
  <button
    className={classNames({
      [styles.clipsPlayPauseButton]: true,
      [styles.clipsPlayPauseButtonDisabled]: disableRewindPlayButton,
    })}
    aria-disabled={disableRewindPlayButton}
    disabled={disableRewindPlayButton}
    type="button"
    data-testid="clips-play-pause-button"
    onClick={onClick}
    aria-label={isPlaying ? 'Pause Clip' : 'Play Clip'}
  >
    {disableRewindPlayButton && <ClipsPlayButtonDisabledSVG />}
    {!disableRewindPlayButton &&
      (isPlaying ? (
        <ClipsPauseButtonSVG bgFill={bgFill} pathFill={pathFill} />
      ) : (
        <ClipsPlayButtonSVG bgFill={bgFill} pathFill={pathFill} />
      ))}
  </button>
);

export default ClipsPlayPauseButton;
